'use strict';

var React = require('react');

var SvgMentionMajor = function SvgMentionMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.738 4.987a5.5 5.5 0 0 1 7.762 5.013c0 .874-.227 1.44-.5 1.773a1.255 1.255 0 0 1-1 .477c-.639 0-.96-.222-1.162-.523-.236-.355-.374-.93-.374-1.727v-2.571a.75.75 0 0 0-1.28-.531c-.438-.3-1.012-.505-1.755-.505-1.159 0-1.952.6-2.422 1.352-.45.72-.614 1.58-.614 2.255 0 .674.164 1.536.614 2.255.47.752 1.263 1.352 2.422 1.352.95 0 1.655-.467 2.119-.937l.069-.072c.515.745 1.326 1.152 2.383 1.152.824 0 1.6-.347 2.157-1.023.55-.668.843-1.601.843-2.727a7 7 0 1 0-3.01 5.751.75.75 0 1 0-.854-1.232 5.5 5.5 0 1 1-5.398-9.532Zm3.276 5.877a7.04 7.04 0 0 1-.05-.864v-.976l-.033-.075c-.09-.204-.173-.392-.352-.598-.2-.228-.522-.458-1.15-.458-.556 0-.906.256-1.15.647-.265.424-.386.991-.386 1.46s.121 1.036.386 1.46c.244.39.594.647 1.15.647.42 0 .763-.199 1.052-.491a3.16 3.16 0 0 0 .534-.752Z"
  }));
};
SvgMentionMajor.displayName = "MentionMajor";

exports.SvgMentionMajor = SvgMentionMajor;
